export const encodeToBase64 = (str: string): string => {
    return btoa(unescape(encodeURIComponent(str)));
};

export const decodeBase64ToText = (base64String: string): string => {
    return atob(base64String);
};


export const dateFormat_YYYY_mm_dd = (dateString: string) =>{
    const date = new Date(dateString);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    // Format as yyyy-mm-dd
    return `${year}-${month}-${day}`;
}

export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
  
    // Use toLocaleDateString to format the date
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  
    return formattedDate;
  }